import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Tool = ({ tool }) => {
    const { _id, name, description, Price, minOrderLimit, availableQuantity, picture } = tool;
    const navigate = useNavigate();

    const handleNavigateClick = id => {
        navigate(`/tool/${id}`);
    }
    return (
        <div className="card w-[315px] lg:w-96 bg-green-50 text-black">
            <figure><img className='object-cover lg:w-96 w-72 lg:h-96 h-72' src={picture} alt="car!" /></figure>
            <div className="card-body h-[400px] mt-[-120px]">
                <h5 className="card-title bg-secondary text-secondary-content p-2 block rounded-xl mb-[-15px] z-20">Lens: {name}</h5>
                <table className="table border-info">
                    <thead className='bg-info'>
                        <tr>
                            <th scope="col">PRICE</th>
                            <th scope="col">MOQ</th>
                            <th scope="col">APQ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>${Price}</td>
                            <td>{minOrderLimit}</td>
                            <td>{availableQuantity}</td>
                        </tr>
                    </tbody>
                </table>
                <p className='text-md'>{description}</p>
                <div className="card-actions justify-end mb-20px">
                    <button onClick={() => handleNavigateClick(_id)} className='btn btn-primary shadow'>Order</button>
                </div>
            </div>
        </div>
    );
};

export default Tool;